<template>
  <generic-modal
    size="large"
    :title="$t('student portal inscription')"
    icon="signature"
    image="/images/icons/student_portal_1.png"
    v-on:destroy="destroy"
    :on_finished="finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="two fields">
          <div class="field">
            <label for>{{ $t("student finder") }}</label>
            <div class="ui blue search" ref="student_search">
              <div class="ui icon input">
                <input
                  class="prompt"
                  type="text"
                  name="student"
                  :placeholder="$t('search student')"
                  ref="student_name"
                />
                <i class="search icon"></i>
              </div>
              <div class="results"></div>
            </div>
          </div>
          <div class="field">
            <div class="two fields">
              <div class="field">
                <label for>{{ $t("username") }}</label>
                <input type="text" name="username" v-model="username" />
              </div>
              <div class="field">
                <label for>{{ $t("password") }}</label>
                <input type="password" name="password" v-model="password" />
              </div>
            </div>
          </div>
        </div>
        <div class="two fields">
          <div class="field">
            <div class="ui horizontal cards" v-if="student">
              <div class="card">
                <div class="image">
                  <img src="/images/icons/matthew.png" />
                </div>
                <div class="content">
                  <div class="header">{{ student.name }}</div>
                  <div class="meta">
                    <a>Friends</a>
                  </div>
                  <div class="description">
                    <!-- <pre>{{ student }}</pre> -->
                  </div>
                  <div
                    class="ui basic mini icon labeled button"
                    @click="edit_student"
                  >
                    <i class="edit orange icon"></i>
                    {{ $t("edit") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="field">
            <label for=""> {{ $t("status") }} </label>
            <div class="ui toggle checkbox">
              <input type="checkbox" name="is_active" v-model="is_active" />
              <label> {{ $t("is active") }} </label>
            </div>
          </div>
        </div>
        <div class="ui message error"></div>
      </div>
    </div>
    <template v-for="(mdl, index) in student_modals">
      <component
        :is="mdl"
        :key="index"
        :student_uuid="student ? student.uuid : ''"
        v-on:succedded="succedded"
      ></component>
    </template>
  </generic-modal>
</template>

<script>
import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import StudentModal from "@/modules/student/StudentModal";
import sha1 from "js-sha1";
import { clone } from "@/utils";

export default {
  name: "StudentPortalUserModal",
  components: {
    "generic-modal": GenericModal,
  },
  props: {
    student_in: Object,
    portal_user_in: Object,
  },
  computed: {},
  data() {
    return {
      student: undefined,
      student_modals: [],
      uuid: undefined,
      username: undefined,
      password: undefined,
      is_active: false,
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      window.jQuery(this.$refs.form).form("validate form");
      let isValid = window.jQuery(this.$refs.form).form("is valid");
      let vm = this;
      return new Promise((resolve, reject) => {
        if (isValid) {
          local_api(vm, "post", "/student_portal/users/do-save", {
            s: vm.student.student_id,
            u: vm.username,
            p: vm.password ? sha1(vm.password) : undefined,
            i: vm.uuid,
            t: vm.is_active ? "A" : "I",
          })
            .then((response) => {
              vm.$emit("succedded", response);
              resolve(response);
            })
            .catch((err) => {
              window.jQuery(this.$refs.form).form("add errors", [err]);
              reject(err);
            });
        } else {
          reject();
        }
      });
    },
    edit_student() {
      this.student_modals.push(StudentModal);
    },
    succedded(student) {
      this.student = student;
    },
    remove_mv(movement, index) {
      if (
        this.branch_based &&
        this.branch_based.movements &&
        this.branch_based.movements.length
      )
        this.branch_based.movements.splice(index, 1);
    },
  },
  created() {
    let vm = this;
    // if (vm.student_uuid) {
    //   local_api(vm, "post", "/student/do-get", {
    //     u: vm.student_uuid,
    //   })
    //     .then((student) => {
    //       vm.student = student;
    //     })
    //     .catch((err) => {
    //       vm.$alertify.error(stringify(err));
    //     });
    // }

    if (vm.student_in) {
      vm.student = clone(vm.student_in);
    }

    if (vm.portal_user_in) {
      vm.username = vm.portal_user_in.username;
      vm.is_active = vm.portal_user_in.status_code == "A";
      vm.uuid = vm.portal_user_in.uuid;
      if (vm.portal_user_in && vm.portal_user_in.std_student) {
        vm.student = clone(vm.portal_user_in.std_student);
      }
    }

    // local_api(vm, "post", "/student_inscription/do-get-configuration", {})
    //   .then((configuration) => {
    //     if (configuration && configuration.setup)
    //       vm.inscription_configuration = JSON.parse(configuration.setup);
    //   })
    //   .catch((err) => {
    //     vm.$alertify.error(stringify(err));
    //   });
  },
  mounted() {
    let vm = this;

    if (vm.portal_user_in && vm.portal_user_in.std_student) {
      window.jQuery(vm.$refs.student_name).val(vm.student.name);
    }

    window.jQuery(this.$refs.form).form({
      fields: {
        student: ["empty"],
        username: ["empty"],
      },
    });

    window.jQuery(this.$refs.student_search).search({
      apiSettings: {
        action: "search student",
        beforeXHR: function(xhr) {
          let token = vm.$session.get("token");
          if (token) {
            xhr.setRequestHeader("x-access-token", token);
          }

          return xhr;
        },
        onResponse: function(response) {
          if (!response.success) vm.$alertify.error(stringify(response.error));
          else {
            var _response = {
              results: [],
            };
            response.data.map((r) => {
              _response.results.push({
                title: r.name,
                description: r.username,
                student: r,
              });
            });
            _response.results.push({
              title: vm.$t("new"),
              description: vm.$t("new student"),
              student: "NEW",
            });
            return _response;
          }
        },
      },
      onSelect(result) {
        if (result.student == "NEW") {
          vm.student_modals.push(StudentModal);
        } else {
          local_api(vm, "post", "/student/do-get", {
            u: result.student.uuid,
          })
            .then((response) => {
              vm.student = response;
            })
            .catch((err) => {
              vm.$alertify.error(stringify(err));
            })
            .finally(() => {
              vm.processing = false;
            });
        }
      },
    });
  },
  watch: {
    student() {},
  },
};
</script>
